// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q4JP","question":"styles_question__2uDj-","description":"styles_description__2zSee"};